export default __webpack_public_path__ + "static/media/chair.3ca333d1.png";